<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>三方公司信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <el-form
        :inline="false"
        :model="addForm"
        :rules="rules"
        ref="formForRef"
        label-width="120px"
        autocomplete="on"
        size="mini"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!--first-->
          <el-tab-pane label="基本信息" name="first">

            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item label="所属省市" prop="province_id">
                  <el-cascader
                    ref="cascaderAddr"
                    style="width: 90%"
                    v-model="areaList"
                    :props="propsdata"
                    :key="isResouceone"
                    @change="handleChangeAddress"
                  >
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item  label="名称" prop="name">
                  <el-input width="400" placeholder="请输入名称"  v-model="addForm.name" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item   label="类别" prop="grade_id" >
                  <el-select width="400" v-model="addForm.cat_id" readonly  placeholder="请选择类别">
                    <el-option
                      v-for="item in cateMenus"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item label="门店编号">
                  <el-input width="400" placeholder="门店编号系统生成" readonly v-model="addForm.sn" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="营业执照负责人" prop="artiperson">
                  <el-input width="400" placeholder="请输入合同编号"  v-model="addForm.artiperson" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="入驻时间">
                  <el-date-picker width="400" clearable type="date" placeholder="选择合同开始时间"    value-format="yyyy-MM-dd" v-model="addForm.contract_start_time" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item label="联系人">
                  <el-input width="400" placeholder="请输入联系人"  v-model="addForm.cont_name" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="联系电话">
                  <el-input width="400" placeholder="请输入联系电话"  v-model="addForm.telephone" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="联系手机">
                  <el-input width="400" placeholder="请输入联系手机"  v-model="addForm.mobile" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="14">
                <el-form-item label="地址">
                  <el-input width="400" placeholder="请输入地址"  v-model="addForm.address" type="text"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="店铺LOGO">
                  <i class="el-icon-camera" style="font-size:80px;" v-show="!addForm.logo" @click="showImgDoc(1,'')"></i>
                  <el-image class="main_image"
                            v-show="addForm.logo" :src="addForm.logo" @click="showImgDoc(1,'')"></el-image>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="图片">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :before-upload="handleBeforeUpload"
                    :on-success="uploadSuccess"
                    :auto-upload="false"
                    :on-change="uploadFile"
                    :file-list="fileList"
                    list-type="picture"
                    multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="图片URL">
                  <el-input v-model="addForm.logo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>


          </el-tab-pane>
          <el-tab-pane label="地址信息" name="second">
            <el-row :gutter="24">
              <el-col :span="14">
                <map-picker :formData="formData" @update="updateMap"  :modelValue="location" />
                  <el-button @click="showLocation">显示当前坐标</el-button>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="店铺详情" name="third">
            <el-row>
              <el-col>
                <!-- 卡片 -->
                <div style="border: 1px solid #ccc;z-index: 9999;">
                  <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                  />
                  <Editor
                    style="height: 300px; overflow-y: hidden;"
                    v-model="addForm.description"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                    @onChange="onChange"
                  />
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="附件资料" name="fourth">

          </el-tab-pane>
        </el-tabs>
        <el-row style="margin-top: 10px;">
          <el-col>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button @click="resetForm('ruleForm')">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <eDocList :formData="formData1"
                :visible.sync="visible1"
                :title="title1"
                :closeForm="closeForm1"
                v-on:eventChoose="eChooseDoc"
      />

    </el-card>
  </div>
</template>
<script>
  import MapPicker from '../common/MapPicker.vue'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import axios from 'axios'
  import moment from 'moment'     //日期时间转换
  import eDocList from "../common/eDocList";
  import CryptoJS from "crypto-js";
  export default {
    name:'thirdShopForm',
    components: {MapPicker, Editor, Toolbar,eDocList },
    data() {
      return {
        formData:{},//地图
        formData1:{},
        title1:'',
        visible1:false,

        type_img:1,
        activeName:'first',
        location: {lng: 118.341854, lat: 35.077435 }, // 默认临沂坐标
        gradeList:[],
        baseUrl:'/api/',
        fileList:[],
        shopList:[],
        dicList:[],
        provinceList:[],
        addForm:{
          cat_id:12,
          logo:'',
          id:'',
          artiperson:'',
          basic_name:"",
          work_status:'',
          status:'',
          name:'',
          sn:'',
          contract_sn:'',
          contract_start_time:'',
          contract_end_time:'',
          grade_id:'',
          province_id:"",
          city_id:"",
          district_id:"",
          sex:'',
          amount:'',
          id_code:'',
          mobile:'',
          remark:'',
          order_time:'',
          summary:"",
          manager_name:'',
          unit_name:"",
          telephone:'',
          address:'',
          cont_name:'',
          shop_id:'',
          description:'',
          shop_img:'',
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          proxy_id:sessionStorage.getItem('proxy_id'),
          lng:'',
          lat:''
        },
        ruleForm:{
          url:'',
          start_time:"",
          ad_id:'',
          ad_name:'',
          ad_link:'',
          position_id:'',
          ad_code:''
        },
        cateMenus:[],
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          name:[
            { required: true, message: "请输入公司名称", trigger: 'change' }
          ],
          provinc_id:[
            { required: true, message: "请选择省市", trigger: 'change' }
          ],

        },
        areaList:[],
        isResouceone: false,
        propsdata: {
          // 懒加载地区列表
          lazy: true,
          lazyLoad(node, resolve) {
           // const { level } = node;
            console.log(node)
            let url= '/api/api/cmp.sys.Region_read_lz/findRegionList';
            setTimeout(() => {
              // 第一級
              if (node.level == 0) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
              //  var _this=this;

                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:1
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                }).catch(function(){
                });
              }
              // 第二級
              if (node.level == 1) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
                // var _this=this;
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                }).catch(function(){
                });
              }
              if (node.level == 2) {
                // Ajax請求數據，填充選擇框
                // // 接口请求获取省份
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: true,
                    }));
                    resolve(nodes);
                  }
                }).catch(function(){
                });
              }
            }, 100);
          },
        },
      }
    },
    mounted() {
      if(this.editor!=null){
        console.log('000')
      }
      // 模拟 ajax 请求，异步渲染编辑器
      this.getCateMenus();
      setTimeout(() => {
        this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
      }, 1500)

      this.getGradeList();
      //let _this=this;
      var id= this.$route.query.id;
      console.log('id-----',id)
      if(!isNaN(id)&&id>0){
        this.addForm.id=id;
        this.getOne();
      }

    },
    methods: {

      updateMap(val){
        this.addForm.lng=val.lng;
        this.addForm.lat=val.lat;
        console.log('map----',val)
      },
      showImgDoc(type){
        this.type_img=type;
        this.title1="图片选择";
        this.visible1=true;
      },
      closeForm1(){
        console.log('this.formData1---',this.formData1)
        this.visible1=false;
      },
      eChooseDoc(id,...params){
        console.log('图片设置')
        console.log('eChooseDoc',params)
        if(this.type_img==1){
          this.addForm.logo=params[1];
        }
      },
      handleClick(){

      },
      showLocation() {
        console.log('当前坐标:', this.location)

        // 提交到后端或其他操作
      },
      handleChangeAddress(){     // 更改时调用
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.addForm.province_id=checkedNode[0].path[0];
        _this.addForm.city_id=checkedNode[0].path[1];
        _this.addForm.district_id=checkedNode[0].path[2];
        // console.log('2222',checkedNode[0].path)
        // console.log( checkedNode[0].data.label ) ;  //获取当前点击节点的label值
        // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
      },
      getDicList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"CCT",
        }
        this.$axios.dicTable(param).then(res=>{
          if(res.code == 200){
            this.dicList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getGradeList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"shopGrade",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.gradeList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getShopList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),

        }
        this.$axios.shopList(param).then(res=>{
          if(res.code == 200){
            this.shopList =res.data;
            this.addForm.shop_id=res.data[0].id;
            this.DataList();
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },

      submitForm(){
        let _this=this;
        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let params=this.addForm;
            if(this.addForm.lng&&this.addForm.lat){
              params.lng=this.addForm.lng;
              params.lat=this.addForm.lat;
            }
            console.log('params------',params)
            _this.$axios.shopSaveLgs(params).then(res=>{
              if(res.code == 200){
                this.$message.success("保存成功");
                this.$router.push('/thirdShopList')
              }
            }).catch(error=>{
              this.$message.error("保存错误");
              console.log(error);
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          id:_this.addForm.id
        };
        this.$axios.shopOne(param).then((res)=>{
          if(res.code==200){
            let item=res.data;
            _this.addForm.name=item.name;
            _this.addForm.grade_id=item.grade_id?item.grade_id:'';
            _this.addForm.shop_id= item.shop_id;
            _this.addForm.artiperson=item.artiperson;

            _this.addForm.province_id=item.province_id;
            _this.addForm.city_id=item.city_id;
            _this.addForm.district_id=item.district_id;
            _this.areaList=[item.province_id,item.city_id,item.district_id];
            console.log(_this.areaList)
            if(item.description){
              _this.addForm.description="ddddd";
            }

            _this.addForm.cat_id= item.cat_id;
            _this.addForm.lng= item.lng;
            _this.addForm.lat= item.lat;
            if(item.lng&&item.lat){

              this.location={ lng:parseFloat(item.lng),lat:parseFloat(item.lat)}
              console.log('9999---location')

            }
            _this.addForm.logo= item.logo;
            _this.addForm.cont_name=item.cont_name;
            _this.addForm.telephone=item.telephone;
            _this.addForm.mobile=item.mobile;
            _this.addForm.address=item.address;
            _this.addForm.sn=item.sn;
            _this.addForm.contract_sn=item.contract_sn;
            _this.addForm.contract_start_time=item.contract_start_time?moment(item.contract_start_time*1000).format('yyyy-MM-DD'):'';

            _this.addForm.contract_end_time=item.contract_end_time?moment(item.contract_end_time*1000).format('yyyy-MM-DD'):'';
            _this.addForm.basic_name=item.basic_name;


            if(_this.addForm.shop_img!=''&&_this.addForm.shop_img!=null){
              var img={
                name:_this.addForm.name,
                url:_this.addForm.shop_img
              }
              _this.fileList.push(img);
            }

          }
          console.log(res);
        });
      },
      async uploadFile (item) {
        let _this=this;
        //let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;

        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => {
          file_md5 = md5;
          console.log('MD5:', md5)
        });
        await this.calculateSHA1(file).then(sha1 => {
          file_sha1 = sha1;
          console.log('SHA1:', sha1);
        });

        // 获取文件名
        const fileName = file.name;
        // 获取文件大小
        const fileSize = file.size;
        // 获取文件后缀
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

        console.log('文件名称：', fileName);
        console.log('文件后缀：', fileExtension);
        console.log('文件大小：', fileSize);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };
        this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200) {
            //文件已经存在
            _this.ruleForm.logo = res.data.url;
            var img = {
              name: res.data.name,
              url: res.data.url
            }
            _this.fileList.push(img);

          } else {

            let param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id')
            };
            this.$axios.getAliJsonCmp(param).then(res => {
              let data = res['data'];
              console.log('aliyun', data);
              let suffix = _this.get_suffix(file.name);
              let autoname = _this.Ymdhis();
              let key = data['dir'];
              let host = data['host'];
              let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
              let request = new FormData();
              request.append('name', file.name);
              request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
              request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
              request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
              request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
              request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
              request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
              request.append('file', file);//需要上传的文件 file
              console.log('aliyun5555', request);
              axios.post(host, request, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
                //请求成功，触发then中的函数
                console.log('upload -res--------', res)
                var fileurl = res.data.filename; //上传完成后的文件oss地址
                var fullurl = host + '/' + fileurl;
                _this.ruleForm.logo = fullurl;
                var img = {
                  name: fileName,
                  url: fullurl
                }
                _this.fileList.push(img);
                //更新上传资料
                let upload_params = {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  name: fileName,
                  size: fileSize,
                  ext: fileExtension,
                  md5: file_md5,
                  sha1: file_sha1,
                  path: fileurl,
                  url: fullurl,
                  status: 1,
                };
                console.log('upload---save params', upload_params)
                _this.$axios.uploadSave(upload_params).then(resu => {
                  console.log('upload---save', resu)
                });

              })
                .catch(error =>
                  //请求失败，触发catch中的函数 可省略
                  console.log(error)
                )
            });

          }
        });
      },
      async readFileAsBinaryString(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsBinaryString(file);
        });
      },
      async  calculateMD5(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.MD5(words).toString();
        });
      },
      async calculateSHA1(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.SHA1(words).toString();
        });
      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload() {
        console.log('aaaaa');
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },

      getCateMenus(){


        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findShopCategoryTree(param).then(res=>{
          if(res.code == 200){
            this.cateMenus =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      uploadImg(file, insertFn){
        let _this=this;
        let param={
          access_token: sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJsonCmp(param).then(res=>{
          console.log('ali_json------',res)

          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

          // let fParam=
          //  {
          //    name:file.name,
          //    key:key +'mrh/'+ autoname + suffix,
          //    policy:data['policy'],
          //    OSSAccessKeyId:data['accessid'],
          //    success_action_status:'200',
          //    callback:data['callback'],
          //    Signature:data['signature'],
          //    file:file
          //  };
          //
          //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}
          let path=data['path']!=null&&data['path']!=undefined?data['path']:'';
          let request = new FormData();

          request.append('name', file.name);
          request.append("key", key +path+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);


          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
          // $.ajax({
          //   url: host,
          //   data: request,
          //   processData: false,//默认true，设置为 false，不需要进行序列化处理
          //   cache: false,//设置为false将不会从浏览器缓存中加载请求信息
          //   async: false,//发送同步请求
          //   contentType: false,//避免服务器不能正常解析文件---------具体的可以查下这些参数的含义
          //   // dataType: 'json',//不涉及跨域  写json即可
          //   type: 'post',
          //   success: function (callbackHost, request) { //callbackHost：success,request中就是 回调的一些信息，包括状态码什么的
          //     console.log(callbackHost);
          //     var fileurl = callbackHost.filename; //上传完成后的文件oss地址
          //     var fullurl=host+'/'+fileurl;
          //     var fileObj={
          //       'file_url':fullurl,
          //       'file_path':fileurl
          //     };
          //     console.log(fileObj);
          //     let tempList=vm.picList;
          //     console.log(tempList);
          //     tempList.push(fileObj);
          //    // vm.picList=tempList;
          //
          //     // $('#m-f-up').append("<li><a href='../images/demopic4.jpg'><img src='../images/demopic4.jpg' /></a><i  class='iconfont icon-weikaitong'></i></li>");
          //     //   $('#ad_code').val(fullurl);
          //     // $("#upload_img_icon img").attr('src',fullurl);
          //   },
          //   error: function(XMLHttpRequest, textStatus, errorThrown) {
          //     alert(XMLHttpRequest.status);
          //     alert(XMLHttpRequest.readyState);
          //     alert(textStatus);
          //   }
          // });
        });

        // let imgData = new FormData();
        // imgData.append('file', file);
        // console.log('lu-----------',file)
        // //调用上传图片接口，上传图片  我这里testUpImg是测试接口
        // testUpImg(imgData).then(response => {
        //   if(response.data.code == 0){
        //     //插入后端返回的url
        //     insertFn(response.data.data.url);
        //   }else{
        //   }
        // })
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      onChange(){
        // this.ruleForm.content=this.editor.txt.html();
      },

      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },

    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>
<style>
  /deep/ .input__inner{color:#333}
  .w-e-modal{z-index: 999 !important;left: 300px !important;top: 300px !important;}
  .main_image img {
    width: 100px; /* 设置图片宽度 */
    height: 100px; /* 设置图片高度 */
    display: block;
  }
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
